var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellNavFilled = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.167 4.056V2h-2.334v2.078c-1.164.154-2.49.549-3.645 1.341C7.572 6.527 6.417 8.326 6.417 11v4.52l-2.48 1.7.73 1.78h18.666l.729-1.78-2.479-1.7V11c0-1.083-.215-2.8-1.283-4.277-.98-1.353-2.614-2.417-5.133-2.667M14 23c1.61 0 2.917-1.12 2.917-2.5h-5.834c0 1.38 1.306 2.5 2.917 2.5",
    clipRule: "evenodd"
  })));
};
export default SvgBellNavFilled;